import { Route, Routes } from "react-router-dom";
import { LateReconciliation } from "./list";

export default function LateReconciliationRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LateReconciliation />} />
      <Route path="/edit" element={<p>Editar</p>} />
    </Routes>
  );
}
